import React from 'react';
import { CContainer, CBreadcrumb, CBreadcrumbItem, 
  CCard, CCardHeader, CCardBody, CRow, CCol } from '@coreui/react';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from '../../hooks/useTranslation';
import StockInputs from '../../components/StockInputs/StockInputs';
import { addStockRequest } from '../../store/stock/stockActions';

const CreateStock = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const isLoading = useSelector(state => state.stockReducer.isLoading);
  const submitResponse = useSelector(state => state.stockReducer.addStockData);

  const handleSubmit = (data) => {
    dispatch(addStockRequest({ ...data, navigate }));
  };

  const handleCancel = () => {
    navigate('/stock');
  };

  return (
    <CContainer>
      <CBreadcrumb className="mb-4">
        <CBreadcrumbItem href="#/stock" 
        onClick={e => { e.preventDefault(); handleCancel(); }}>{t('stock')}</CBreadcrumbItem>
        <CBreadcrumbItem active>{t('createStock')}</CBreadcrumbItem>
      </CBreadcrumb>
      <CRow>
        <CCol xs={12}>
          <CCard>
            <CCardHeader><h4>{t('createStock')}</h4></CCardHeader>
            <CCardBody>
              <StockInputs onSubmit={handleSubmit}
               onCancel={handleCancel} isLoading={isLoading} 
               submitResponse={submitResponse} />
            </CCardBody>
          </CCard>
        </CCol>
      </CRow>
    </CContainer>
  );
};

export default CreateStock; 